/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { graphql, useStaticQuery } from "gatsby"
import versions from "../../services/versions"

import sharingImage from "../../resources/img/social/sharing.png"

const defaultLang = process.env.LANG_TAG ? process.env.LANG_TAG : 'en';

function SEO({description, lang = defaultLang, meta = [], fullTitle, title, image, path, alternatePath, validUrls = null, fr = true, eu = true, uk = true, us = true}) {
  const {site} = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            localisedTitle
            description
            author
          }
        }
      }
    `
  );

  const websiteUrl = process.env.WEBSITE_URL;
  const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us";

  const getLocalisedPath = (path, version, alternatePath = false) => {
    let localisedPath = path

    if (
      alternatePath &&
      ((activeEnv !== "fr" && version === "fr") ||
        (activeEnv === "fr" && version !== "fr"))
    ) {
      localisedPath = alternatePath.replace(`/${activeEnv}`, "")
    }

    return localisedPath
  }

  const fixTrailingSlash = (path) => {
    if (path.length === 0) return path

    if (path.charAt(path.length - 1) === "/") return path

    return path + "/"
  }

  const metaDescription = description || site.siteMetadata.description;
  const socialSharingImage = image || websiteUrl + sharingImage;
  const url = websiteUrl + path;
  const pageUrl = url.substr(-1) === '/' ? url.substr(0, url.length - 1) : url;
  const versionKeys = Object.keys(versions)
  const purePath = path?.replace(`/${activeEnv}`, "")

  let hrefLang = process.env.LANG_TAG.toLowerCase();


  if (hrefLang === "en") {
    hrefLang = "x-default"
  }

  let alternateVersions = []

  if (versionKeys) {
    versionKeys.forEach((key) => {
        const versionData = versions[key]
        const isUS = key === 'us'
        const versionUrl = isUS ? websiteUrl : websiteUrl + `/${versionData.pathname}`;
        let data = {rel: 'alternate', href: fixTrailingSlash(versionUrl + getLocalisedPath(purePath, key, alternatePath)), hrefLang: versionData.hrefLang}

        if (validUrls) {
          const validUrl = validUrls.find((url) => {
            if (isUS) {
              return (
                !url.includes("/eu/") &&
                !url.includes("/uk/") &&
                !url.includes("/fr/")
              )
            } else {
              return url.includes(`/${key}/`)
            }
          })

          if (!validUrl) {
            return
          }

          data = {
            rel: "alternate",
            href: fixTrailingSlash(validUrl),
            hrefLang: versionData.hrefLang,
          }
        }

        if (key === "fr") {
          if (fr === true)  {
            alternateVersions.push(data)
          }
        } else if (key === "eu") {
          if (eu === true) {
            alternateVersions.push(data)
          }
        } else if (key === "uk") {
          if (uk === true) {
            alternateVersions.push(data)
          }
        } else {
          if (us === true) {
            alternateVersions.push(data)
          }
        }
    })
  }

  let localisedTitle = title;

  if ((activeEnv !== "us" && path !== "/paris-store") || (activeEnv === "us" && path === "/paris-store")) {
    if (title.includes("Kimai")) {
      localisedTitle = title.replace("Kimai", `Kimai ${activeEnv.toUpperCase()}`)
    } else {
      localisedTitle = title.replace("Kimaï", `Kimaï ${activeEnv.toUpperCase()}`)
    }
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={localisedTitle}
      titleTemplate={fullTitle ? `%s` : `%s | ${site.siteMetadata.localisedTitle}`}
      link={[
        ...alternateVersions
      ]}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:url`,
          content: pageUrl,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: socialSharingImage,
        },
        {
          property: `fb:app_id`,
          content: `2243518289231235`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `twitter:image:src`,
          content: socialSharingImage,
        },
      ]
        .concat(meta)}
    />
  )
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  title: PropTypes.string.isRequired,
  path: PropTypes.string
};

export default SEO
